import React, {useState} from 'react';
import {__} from '@wordpress/i18n';
import {useClassRegistrationFormStore} from "./store";

const PersonForm = ({inputPrefix, sexSectionLabel, personSex, setPersonSex, register, errors}) => {
  const [personIsUnderage, setPersonIsUnderage] = useState(false);

  // Store data.
  const isOnlyFormWomen = useClassRegistrationFormStore((state) => state.isOnlyFormWomen);
  const availableSex = useClassRegistrationFormStore((state) => state.availableSex);

  const handlePersonSexChange = ({target}) => {
    setPersonSex(target.value);
  }

  return (
    <>
      <div className="form__row">
        <div className="form__column">
          <label className="form__label">{sexSectionLabel}</label>
          <div className="form__radio-buttons form__radio-buttons--horizontal">
            {tanecniskola_class_registration.sex.map((item, index) => {
              if (!isOnlyFormWomen || (isOnlyFormWomen && item.value === 'female')) {
                return (
                  <div className="form__radio" key={item.value}>
                    <input type="radio" id={`${inputPrefix}sex_${item.value}`} value={item.value}
                           checked={(personSex === item.value)}
                           disabled={!availableSex.includes(item.value)}
                           readOnly={('second_person_' === inputPrefix)}
                           onChange={handlePersonSexChange}
                           autoComplete="off"
                           required
                    />
                    <label htmlFor={`${inputPrefix}sex_${item.value}`}>
                      {item.label}
                      {!availableSex.includes(item.value) &&
                        <div className='form__error'>
                          {__('Kapacita je již naplněna.', 'tanecniskola')}
                        </div>
                      }
                    </label>
                  </div>
                );
              }
            })}
          </div>
        </div>
      </div>

      <div className="form__row">
        <div className="form__column">
          <div className="form__item">
            <label className="form__label" htmlFor={`${inputPrefix}first_name`}>{__('Jméno', 'tanecniskola')}</label>
            <input id={`${inputPrefix}first_name`} {...register(`${inputPrefix}first_name`, {
              required: __('Toto pole je povinné.', 'tanecniskola'),
            })} />
            {errors[`${inputPrefix}first_name`] &&
              <div className="form__error">{errors[`${inputPrefix}first_name`].message}</div>}
          </div>
        </div>
        <div className="form__column">
          <div className="form__item">
            <label className="form__label" htmlFor={`${inputPrefix}last_name`}>{__('Příjmení', 'tanecniskola')}</label>
            <input id={`${inputPrefix}last_name`} {...register(`${inputPrefix}last_name`, {
              required: __('Toto pole je povinné.', 'tanecniskola'),
            })} />
            {errors[`${inputPrefix}last_name`] &&
              <div className="form__error">{errors[`${inputPrefix}last_name`].message}</div>}
          </div>
        </div>
      </div>

      <div className="form__row">
        <div className="form__column">
          <div className="form__item">
            <label className="form__label" htmlFor={`${inputPrefix}phone`}>{__('Telefon', 'tanecniskola')}</label>
            <input type="tel" id={`${inputPrefix}phone`}
                   {...register(`${inputPrefix}phone`, {
                     required: __('Toto pole je povinné.', 'tanecniskola'),
                     pattern: {
                       value: /^(\+420|\+421|00420|00421)?[ ]*[0-9]{3}[ ]*[0-9]{3}[ ]*[0-9]{3}$/,
                       message: __('Zadejte validní telefonní číslo.', 'tanecniskola')
                     }
                   })} />
            {errors[`${inputPrefix}phone`] &&
              <div className="form__error">{errors[`${inputPrefix}phone`].message}</div>}
          </div>
        </div>
        <div className="form__column">
          <div className="form__item">
            <label className="form__label" htmlFor={`${inputPrefix}email`}>{__('E-mail', 'tanecniskola')}</label>
            <input type="email" id={`${inputPrefix}email`}
                   {...register(`${inputPrefix}email`, {
                     required: __('Toto pole je povinné.', 'tanecniskola'),
                     pattern: {
                       value: /\S+@\S+\.\S+/,
                       message: __('Zadejte validní e-mailovou adresu.', 'tanecniskola')
                     }
                   })} />
            {errors[`${inputPrefix}email`] &&
              <div className="form__error">{errors[`${inputPrefix}email`].message}</div>}
          </div>
        </div>
      </div>

      <div className="form__row">
        <div className="form__column">
          <div className="form__item">
            <label className="form__label" htmlFor={`${inputPrefix}street`}>{__('Ulice a č.p.', 'tanecniskola')}</label>
            <input id={`${inputPrefix}street`} {...register(`${inputPrefix}street`, {
              required: __('Toto pole je povinné.', 'tanecniskola'),
            })} />
            {errors[`${inputPrefix}street`] &&
              <div className="form__error">{errors[`${inputPrefix}street`].message}</div>}
          </div>
        </div>
      </div>

      <div className="form__row">
        <div className="form__column">
          <div className="form__item">
            <label className="form__label" htmlFor={`${inputPrefix}city`}>{__('Město', 'tanecniskola')}</label>
            <input id={`${inputPrefix}city`} {...register(`${inputPrefix}city`, {
              required: __('Toto pole je povinné.', 'tanecniskola'),
            })} />
            {errors[`${inputPrefix}city`] &&
              <div className="form__error">{errors[`${inputPrefix}city`].message}</div>}
          </div>
        </div>
        <div className="form__column form__column--small">
          <div className="form__item">
            <label className="form__label" htmlFor={`${inputPrefix}zip`}>{__('PSČ', 'tanecniskola')}</label>
            <input id={`${inputPrefix}zip`} {...register(`${inputPrefix}zip`, {
              required: __('Toto pole je povinné.', 'tanecniskola'),
            })} />
            {errors[`${inputPrefix}zip`] && <div className="form__error">{errors[`${inputPrefix}zip`].message}</div>}
          </div>
        </div>
      </div>

      <div className="form__row">
        <div className="form__column">
          <div className="form__checkbox">
            <input type="checkbox" name={`${inputPrefix}is_underage`} id={`${inputPrefix}is_underage`}
                   autoComplete="off"
                   checked={personIsUnderage}
                   onChange={e => {
                     setPersonIsUnderage(e.target.checked)
                   }}
            />
            <label htmlFor={`${inputPrefix}is_underage`}>{__('Jsem mladší 18 let', 'tanecniskola')}</label>
            <svg xmlns="http://www.w3.org/2000/svg" width="13.25" height="9.5" viewBox="0 0 13.25 9.5">
              <path id="Path_3266" data-name="Path 3266" d="M8.75,15.5a1,1,0,0,1-.707-.293l-3.75-3.75a1,1,0,0,1,1.414-1.414L8.75,13.086l6.793-6.793a1,1,0,1,1,1.414,1.414l-7.5,7.5A1,1,0,0,1,8.75,15.5Z" transform="translate(-4 -6)" fill="#fff"/>
            </svg>
          </div>
        </div>
      </div>

      {personIsUnderage &&
        <div className="form__row">
          <div className="form__column">
            <div className="form__item">
              <label className="form__label"
                     htmlFor={`${inputPrefix}parent_email`}>{__('E-mail zákonného zástupce', 'tanecniskola')}</label>
              <input type="email" id={`${inputPrefix}parent_email`}
                     autoComplete="off"
                     {...register(`${inputPrefix}parent_email`, {
                       required: __('Toto pole je povinné.', 'tanecniskola'),
                       pattern: {
                         value: /\S+@\S+\.\S+/,
                         message: __('Zadejte validní e-mailovou adresu.', 'tanecniskola')
                       }
                     })} />
              {errors[`${inputPrefix}parent_email`] &&
                <div className="form__error">{errors[`${inputPrefix}parent_email`].message}</div>}
            </div>
          </div>
        </div>
        }
    </>
  );
};

export default PersonForm;